import educationEn from './education.en';
import educationAr from './education.ar';

export function getEducation(lang = 'en') {
  return lang === 'ar' ? educationAr : educationEn;
}
